import * as React from 'react'
import { useSelector } from 'react-redux'
import { Box, Tab, Tabs, Grid, Paper } from '@mui/material'

import ListAltIcon from '@mui/icons-material/ListAlt'
import { TabPanel } from '../../components/TabPanel'
import FamilyTable from '../../components/Table/family'
import SpecieTable from '../../components/Table/specie'
import UserTable from '../../components/Table/user'
import PropTypes from 'prop-types'

const STYLE_TABS = {
  orientation: 'vertical',
  variant: 'scrollable',
  'aria-label': 'vertical tabs',
  sx: { borderRight: 1, borderColor: 'divider', width: '120px', height: '100%' },
}

const STYLE_TAB = {
  fontSize: 12,
  color: '#0000008a',
  '&:hover': { color: 'var(--color-primary)' },
  selected: false,
}

const STYLE_BOX = {
  flexGrow: 1,
  bgcolor: 'background.paper',
  display: 'flex',
}

const ManagementTable = () => {
  const [value, setValue] = React.useState(0)
  const _state = useSelector(state => state.drawerLeft)

  const handleChange = (event, newValue) => setValue(newValue)

  const styleBoxContainerMap = {
    ml: _state.open ? `${_state.drawerWidth}px` : 0,
    mt: _state.drawerHeight,
    width: `100%`,
    height: _state.contentBox,
    display: 'flex',
    flexDirection: 'row',
  }

  function a11yProps(index) {
    return {
      id: `tab-incov-${index}`,
      'aria-controls': `tabpanel-inconvs-${index}`,
    }
  }

  return (
    <Box sx={styleBoxContainerMap}>
      <Paper sx={{ px: 3, width: '100%', mt: 2 }}>
        <Box sx={{ border: 1, borderColor: 'divider', ...STYLE_BOX }}>
          <Tabs value={value} onChange={handleChange} {...STYLE_TABS}>
            <Tab
              key={`tab-${0}`}
              sx={STYLE_TAB}
              label="Familias"
              {...a11yProps(0)}
              icon={<ListAltIcon />}
            />
            <Tab
              key={`tab-${1}`}
              sx={STYLE_TAB}
              label="Especies"
              {...a11yProps(1)}
              icon={<ListAltIcon />}
            />
            <Tab
              sx={STYLE_TAB}
              key={`tab-${2}`}
              label="Usuarios"
              {...a11yProps(2)}
              icon={<ListAltIcon />}
            />

            {/* 
            <Tab
              key={`tab-${3}`}
              sx={STYLE_TAB}
              label="Sitio"
              {...a11yProps(3)}
              icon={<ListAltIcon />}
            /> */}
          </Tabs>
          <TabPanel key={`TabFamily-${1}`} value={value} index={0}>
            <Grid container spacing={2}>
              <FamilyTable />
            </Grid>
          </TabPanel>
          <TabPanel key={`TabSpecie-${2}`} value={value} index={1}>
            <Grid container spacing={2}>
              <SpecieTable />
            </Grid>
          </TabPanel>
          <TabPanel key={`TabUser-${3}`} value={value} index={2}>
            <Grid container spacing={2}>
              <UserTable />
            </Grid>
          </TabPanel>
        </Box>
      </Paper>
    </Box>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

export default ManagementTable
